import { colors, theme } from './theme';
import { getTheme } from './constants';
export { default as ThemeProvider } from './ThemeProvider';
export { theme, colors, getTheme };
export default theme;